import { Moon, Sun, Monitor } from 'lucide-react';

import { useTheme } from './ThemeProvider';

import { Button } from '@/components/ui/button';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycleTheme = () => {
    const nextTheme = {
      light: 'dark',
      dark: 'system',
      system: 'light',
    } as const;
    setTheme(nextTheme[theme]);
  };

  const icon = {
    light: <Sun className="h-4 w-4" />,
    dark: <Moon className="h-4 w-4" />,
    system: <Monitor className="h-4 w-4" />,
  }[theme];

  const label = {
    light: '라이트 모드',
    dark: '다크 모드',
    system: '시스템 설정',
  }[theme];

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={cycleTheme}
      aria-label={`현재: ${label}. 클릭하여 테마 변경`}
      title={label}
    >
      {icon}
    </Button>
  );
}
